import React from 'react';
import { Control } from 'react-hook-form';

import { useGetFirmsQuery } from '../../services/api/firmsService';
import {
  Combobox,
  ComboboxLabel,
  ComboboxOption,
} from '../ui/catalyst/combobox';
import { ErrorMessage, Field, Label } from '../ui/catalyst/fieldset';
import { FormSection } from './FormSection';

interface FirmSectionProps {
  control: Control<any>;
  errors: any;
  selectedFirm: { id: string; name: string } | null;
  setSelectedFirm: (firm: { id: string; name: string } | null) => void;
  setValue: any;
  isLoading: boolean;
  isUpdateMode?: boolean;
}

export const FirmSection: React.FC<FirmSectionProps> = ({
  control,
  errors,
  selectedFirm,
  setSelectedFirm,
  setValue,
  isLoading,
  isUpdateMode = false,
}) => {
  const { data: firms, isLoading: firmsLoading } = useGetFirmsQuery({});

  const firmOptions =
    firms?.map((firm) => ({
      id: firm.id,
      name: firm.name,
    })) || [];

  const handleFirmChange = (firm: { id: string; name: string } | null) => {
    setSelectedFirm(firm);
    setValue('firm', firm || { id: '', name: '' }, { shouldValidate: true });
  };

  return (
    <FormSection
      title="Firm"
      description="The law firm associated with the client"
    >
      <div className="space-y-6">
        <Field>
          <Label>
            Firm <span className="text-red-500">*</span>
          </Label>
          <Combobox
            value={selectedFirm}
            onChange={handleFirmChange}
            options={firmOptions}
            displayValue={(firm) => firm?.name}
            placeholder="Select a firm"
            className="w-full"
            aria-label="Select a firm"
            disabled={firmsLoading || isUpdateMode}
          >
            {(option) => (
              <ComboboxOption value={option}>
                <ComboboxLabel>{option.name}</ComboboxLabel>
              </ComboboxOption>
            )}
          </Combobox>
          {errors.firm?.id?.message && (
            <ErrorMessage>{errors.firm.id.message}</ErrorMessage>
          )}
        </Field>
      </div>
    </FormSection>
  );
};
